import { Stack, Typography } from "@mui/material";

export default function StockCell({ stock }) {
  if (!stock) return "-";
  return (
    <Stack direction="row" alignItems="center">
      <Typography
        variant="body2"
        fontWeight={400}
        sx={{ color: "#00000099", fontSize: "14px" }}
      >
        {stock} un.
      </Typography>
    </Stack>
  );
}
